import { getHeadersWithTokens } from 'api/ApiHelpers';
import ClientInstance from 'api/ClientInstance';

interface IadminEndpoints {
  postDirector: (centerId: number, body: any) => Promise<any>;
  putDirector: (centerId: number, directorId: number, body: any) => Promise<any>;
  putMoveDirectors: (body: any, centerId: number) => Promise<any>;
  getDirectorDetailAsTeacher: (centerId: number, directorId: number) => Promise<any>;
}

const directorEndpoints: IadminEndpoints = {
  postDirector: (centerId: number, body: any) => ClientInstance.post(`/organizations/shared/centers/${centerId}/directors`, body),
  getDirectorDetailAsTeacher: (directorId: number, centerId: number) => ClientInstance.get(`/centers/shared/centers/${centerId}/directors/${directorId}`),
  // putDirector: (centerId: number, directorId: number, body: any) => ClientInstance.put(`/organizations/shared/centers/${centerId}/directors/${directorId}`, body),
  putDirector: (centerId: number, directorId: number, body: any) => ClientInstance.put(`/organizations/shared/staff/${directorId}`, body),
  putMoveDirectors: (body: any, centerId: number) => ClientInstance.put(`organizations/shared/centers/${centerId}/directors/reassign`, body, getHeadersWithTokens(true)),
};

export default directorEndpoints;
